import { render, staticRenderFns } from "./CityWiseARTRegistered.vue?vue&type=template&id=3fb37ad8&scoped=true&"
import script from "./CityWiseARTRegistered.vue?vue&type=script&lang=js&"
export * from "./CityWiseARTRegistered.vue?vue&type=script&lang=js&"
import style0 from "./CityWiseARTRegistered.vue?vue&type=style&index=0&id=3fb37ad8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb37ad8",
  null
  
)

export default component.exports